export const FIELD_ROUNDED = "rounded-lg";

export const INPUT_CLASS =
  `w-full px-3.5 py-2.5 text-sm text-cfHeadingText border border-cfSignInSignUpInputBorder ${FIELD_ROUNDED} shadow-sm placeholder:text-cfSignInSignUpInputPlaceholderText focus:outline-none focus:ring-2 focus:ring-cfPrimary/20 focus:border-cfButton transition-colors duration-150`;

export const LABEL_CLASS = "text-sm font-medium text-cfSignInSignUpInputLabelText";

export const SELECT_TRIGGER_CLASS =
  `w-full px-3.5 py-2.5 text-sm text-cfHeadingText border border-cfSignInSignUpInputBorder ${FIELD_ROUNDED} shadow-sm bg-cfSecondary focus:outline-none focus:ring-2 focus:ring-cfPrimary/20 focus:border-cfButton transition-colors duration-150`;

export const SELECT_CLASS = SELECT_TRIGGER_CLASS;

export const CARD_CLASS =
  "rounded-xl border border-cfCardBorder bg-cfSecondary shadow-sm";

export const INPUT_ERROR_CLASS =
  "border-cfStatusBlockedText focus:border-cfStatusBlockedText focus:ring-cfStatusBlockedText/20";

export const PRIMARY_BUTTON_CLASS =
  "px-4 py-2 bg-cfPrimaryButton text-cfSecondary font-medium rounded-md hover:bg-cfPrimaryDark transition-colors disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-cfPrimary";
